import { debounceResize, throttleScroll, bodyOverflow, isInViewport } from './parts/_utility';
import { initHeader } from './parts/initHeader';
import { initButton } from './parts/initButton';
import { initNavigation } from './parts/initNavigation';
import { initList } from './parts/initList';
import { initPluginDocspress } from './parts/initPluginDocspress';

/*------------------------------------------------------------------

  Harro Class

-------------------------------------------------------------------*/
class HARRO {
  init() {
    // prt:sc:dm
    const self = this;

    self.initHeader();
    self.initButton();
    self.initNavigation();
    self.initList();
    self.initPluginDocspress();
  }

  debounceResize(func) {
    return debounceResize.call(this, func);
  }

  throttleScroll(callback) {
    return throttleScroll.call(this, callback);
  }

  bodyOverflow(type) {
    return bodyOverflow.call(this, type);
  }

  isInViewport($item, returnRect) {
    return isInViewport.call(this, $item, returnRect);
  }

  initHeader() {
    return initHeader.call(this);
  }

  initButton() {
    return initButton.call(this);
  }

  initNavigation() {
    return initNavigation.call(this);
  }

  initList() {
    return initList.call(this);
  }

  initPluginDocspress() {
    return initPluginDocspress.call(this);
  }
}

/*------------------------------------------------------------------

  Init Harro

-------------------------------------------------------------------*/
window.Harro = new HARRO();

if ('undefined' !== typeof window.Harro) {
  window.Harro.init();
}
